var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17,2.5h-3v1h2.5c.28,0,.5.22.5.5v21c0,.28-.22.5-.5.5H1.5c-.28,0-.5-.22-.5-.5V4c0-.28.22-.5.5-.5h2.5v-1H1c-.55,0-1,.45-1,1v22c0,.55.45,1,1,1h16c.55,0,1-.45,1-1V3.5c0-.55-.45-1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.75,2h-2.34c.06-.16.09-.32.09-.5,0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5,1.5c0,.18.04.34.09.5h-2.34c-.14,0-.25.11-.25.25v1.5c0,.14.11.25.25.25h7.5c.14,0,.25-.11.25-.25v-1.5c0-.14-.11-.25-.25-.25Zm-4.25-.5c0-.28.22-.5.5-.5s.5.22.5.5-.22.5-.5.5-.5-.22-.5-.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 7.5,
    width: 2,
    height: 2,
    rx: 0.25,
    ry: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 8,
    width: 7,
    height: 1,
    rx: 0.33,
    ry: 0.33
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 11.5,
    width: 2,
    height: 2,
    rx: 0.25,
    ry: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 12,
    width: 7,
    height: 1,
    rx: 0.33,
    ry: 0.33
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 16,
    width: 7,
    height: 1,
    rx: 0.33,
    ry: 0.33
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.75,15.5h-1.5c-.14,0-.25.11-.25.25v1.5c0,.14.11.25.25.25h1.5c.14,0,.25-.11.25-.25v-1.5c0-.14-.11-.25-.25-.25Zm0,1.62c0,.07-.06.12-.12.12h-1.25c-.07,0-.12-.06-.12-.12v-1.25c0-.07.06-.12.12-.12h1.25c.07,0,.12.06.12.12v1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.fb7ac6ef2c4ed181f353b4c03575542f.svg";
export { ForwardRef as ReactComponent };